declare namespace $ {

	export class $mol_icon_button_cursor extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=cursor.view.tree.d.ts.map